export default "__VITE_ASSET__BYQ$a3Os__"